import { ChargeAccountTransaction } from 'store/types'

const MONEY_FIELDS = ['allowed', 'paidRefund', 'transfers', 'copay', 'writeOff', 'patientWriteOff'] as const

const cents = (value: unknown): number => Math.round(Math.abs(Number(value ?? 0) || 0) * 100)

/**
 * Whether earlier reversals already back this row out in full, field by field
 * — then there is nothing left to reverse and the server refuses another.
 * Reversals sit on the same service line as the row they reverse.
 */
export const isFullyReversed = (
  transaction: ChargeAccountTransaction,
  lineTransactions: ChargeAccountTransaction[],
): boolean => {
  if (!transaction.id) return false

  const reversals = lineTransactions.filter(
    (candidate) => candidate.type === 'REVERSAL' && candidate.reversesId === transaction.id,
  )

  return reversals.length > 0 && MONEY_FIELDS.every(
    (field) => reversals.reduce((sum, reversal) => sum + cents(reversal[field]), 0) >= cents(transaction[field]),
  )
}
